<script>import { connectConfigure } from "instantsearch.js/es/connectors";
import connect from "../connect";
connect(
  connectConfigure,
  { searchParameters: $$props },
  { $$widgetType: "svelte-ais.Configure" }
);
</script>
